import React from 'react';
import PropTypes from 'prop-types';
import { Container } from '@fiverr-private/layout_components';
import { getContext } from '@fiverr-private/fiverr_context';
import { dateStringToHowLongAgo } from '../../../../../utils';
import { GigInfoPropType } from '../../../../FreelancerReviews/FreelancerReviewItem/GigInfo';
import useMedia from '../../../../shared/hooks/useMedia';
import Helpful from '../../../../shared/Helpful';
import MobileView from './MobileView';
import DesktopView from './DesktopView';

const ReliableReviewItem = ({
    review,
    displayTranslationButton,
    translationConfig,
    componentName,
    descriptionText,
    shouldHighlight = false,
    workSampleData,
    showBusinessBadge = false,
    reviewerIndustry,
    gigData,
}) => {
    const {
        created_at: reviewCreationDate,
        comment: originalText,
        reviewer_country_code: countryCode,
        username,
        value: ratingScore,
        repeat_buyer: isRepeatBuyer = false,
        seller_response: sellerResponse,
        user_image_url: userImageUrl,
        order_price_range: priceRange,
        order_duration: orderDuration,
        order_type: orderType,
        is_cancelled_order: isCancelledOrder = false,
    } = review;

    const { locale } = getContext();
    const createdAt = reviewCreationDate ? dateStringToHowLongAgo(reviewCreationDate, locale) : null;
    const isSmallScreen = useMedia();

    const user = {
        has_profile_photo: !!userImageUrl,
        username,
        profile_photo: userImageUrl,
    };

    const commonProps = {
        user,
        createdAt,
        isRepeatBuyer,
        isCancelledOrder,
        showBusinessBadge,
        countryCode,
        ratingScore,
        originalText,
        descriptionText,
        shouldHighlight,
        review,
        priceRange,
        orderDuration,
        orderTypeHourly: orderType === 'HOURLY',
        displayTranslationButton,
        translationConfig,
        componentName,
        workSampleData,
        gigData,
        sellerResponse,
    };

    return (
        <>
            {isSmallScreen ? (
                <MobileView {...commonProps} />
            ) : (
                <DesktopView {...commonProps} reviewerIndustry={reviewerIndustry} />
            )}
            <Container paddingX="3" paddingY="2">
                <Helpful review={review} />
            </Container>
        </>
    );
};

ReliableReviewItem.propTypes = {
    review: PropTypes.shape({
        created_at: PropTypes.string,
        comment: PropTypes.string,
        reviewer_country_code: PropTypes.string,
        username: PropTypes.string,
        value: PropTypes.number,
        is_business: PropTypes.bool,
        reviews_count_as_buyer: PropTypes.number,
        order_price_range: PropTypes.string,
        order_duration: PropTypes.string,
        order_type: PropTypes.string,
    }).isRequired,
    translationConfig: PropTypes.shape({
        isLoading: PropTypes.bool,
        isTranslatedText: PropTypes.bool,
        toggleTranslation: PropTypes.func,
    }),
    workSampleData: PropTypes.shape({
        workSample: PropTypes.string,
        smallWorkSample: PropTypes.string,
        position: PropTypes.number,
    }),
    displayTranslationButton: PropTypes.bool.isRequired,
    descriptionText: PropTypes.string.isRequired,
    showBusinessBadge: PropTypes.bool,
    componentName: PropTypes.string.isRequired,
    reviewerIndustry: PropTypes.array,
    gigData: GigInfoPropType,
};

export default ReliableReviewItem;
